import React, { useState, useContext, useRef, useEffect } from 'react';
import Header from '../../header';
import Sidebar from '../sidebar';
import Footer from '../../footer';
import { AppContext } from '../../../services/AuthContext';
import { createAuthor, getAuthorTitleList, getLanguageAllList, templatesandattributedataListAuthors, templatesListAuthor, templatetypelistAuthor, uniqueidSearch } from '../../../services/authorService';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from 'react-router-dom'; 
import { User17 } from "../../imagepath";
import { Button, Card, CardBody, CardHeader, Col, FormGroup, FormLabel, Row, Tooltip, FormControl, InputGroup, Form, Table } from 'react-bootstrap';
import { Info, Search } from 'react-feather';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UniversitySelector from './UniversitySelector';

const CreateAuthor = () => {


   const { auth } = useContext(AppContext);
    const token = auth.token;
  const emailInputRef = useRef(null);
    
    const [author, setAuthor] = useState({
        uniqueid: '',
        name: '',
        surname: '',
        title: '',
        yokid: '',
        institution: '',
        faculty: '',
        department: '',
        email: '',
        photo: '',
        orcid: '',
        contactpersonSaveDTOList: [],
        authorcustomerrepSaveDTOList: [],
        authorstemplatesandattributedataSaveDTOList: [],
        detailedinformation: {
            tr: ''
        }
    });


    const [titleList, setTitleList] = useState([]);

    useEffect(() => {

        const FetchAuthorTitleList = async () => {
            try {
                const authorsTitle = await getAuthorTitleList(token);
                setTitleList(authorsTitle.data);
            } catch (error) {
                setTitleList([]);
            }
        };
        FetchAuthorTitleList();
    }, [token]);

    const [availableLanguages, setAvailableLanguages] = useState(['tr', 'en']);
    const [selectedLanguages, setSelectedLanguages] = useState(['tr']);
    const [templateType, setTemplateType] = useState("");
    const [typelist, setTypelist] = useState([]);
    const [attr, setAttr] = useState([]);
    const [rows, setRows] = useState([]);
    const [editingRowIndex, setEditingRowIndex] = useState(null);
    const [newRow, setNewRow] = useState({ templateType: '', value: '' });
    const [emailError, setEmailError] = useState('');
    const [languages, setLanguages] = useState([]);
    const [languageOptions, setLanguageOptions] = useState([]);


    const fetchLanguages = async () => {
        try {
            const response = await getLanguageAllList(token);
            const languageList = response?.data?.languageList || [];
            setAvailableLanguages(languageList.map(lang => lang.key));
            setLanguageOptions(languageList);
        } catch (error) {
            setAvailableLanguages([]);
            setLanguageOptions([]);
        }
    };

    useEffect(() => {
        fetchLanguages();
    }, [token]);


    const [newAttribute, setNewAttribute] = useState({
        templatesandattributedataid: '',
        datajson: []
    });
    const [templates, setTemplates] = useState([]);

    const [photo, setPhoto] = useState(null);
    const [files, setFiles] = useState([]);
    const [attributes, setAttributes] = useState([]);


    const fetchTemplate = async (page = 0, size = 10000) => {
        try {
            const response = await templatesListAuthor(1, token, page, size);
            const filteredTemplates = (response.data || []).filter(template => 
                template.name.toLowerCase().includes('yazar')
            );
            setTemplates(filteredTemplates);
            
            if (filteredTemplates.length > 0 && !templateType) {
                setTemplateType(filteredTemplates[0].id.toString());
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleAttrChange = (index, key, value) => {
        const updatedAttributes = [...author.authorstemplatesandattributedataSaveDTOList];
        updatedAttributes[index][key] = value;
        setAuthor({ ...author, authorstemplatesandattributedataSaveDTOList: updatedAttributes });
    };

    const handleRemoveAttribute = (index) => {
        const updatedAttributes = author.authorstemplatesandattributedataSaveDTOList.filter((_, i) => i !== index);
        setAuthor({ ...author, authorstemplatesandattributedataSaveDTOList: updatedAttributes });
    };

    const addNewAttr = () => {
        setAuthor({
            ...author,
            authorstemplatesandattributedataSaveDTOList: [
                ...author.authorstemplatesandattributedataSaveDTOList,
                { ...newAttribute, authorid: 0 }
            ]
        });
        setNewAttribute({ templatesandattributedataid: '', datajson: [] });
    };

    const getType = (val) => {
        setTemplateType(val);
    };

    useEffect(() => {
        const templateTypeList = async () => {
            try {
                const response = await templatetypelistAuthor(1, token);
                setTypelist(response.data);
            } catch (error) {
                setTypelist([]);
            }
        };
        templateTypeList();
        fetchTemplate();
    }, []);

    const [userList, setUserList] = useState([]);




    const fetchAttrDetails = async () => {
        try {
            const responseattr = await templatesandattributedataListAuthors(templateType, 1, token);
            setAttr(responseattr.data);
            setRows([]);
            responseattr.data.forEach((row) => {
                let inputType;
                if (row.attributedata.multidata === 1) {
                    inputType = "multidata";
                } else if (
                    row.attributedata.templatetypeandattribute.attribute.attrtype === 'File' ||
                    row.attributedata.templatetypeandattribute.attribute.attrtype === 'Image'
                ) {
                    inputType = "file";
                } else if (row.attributedata.templatetypeandattribute.attribute.attrtype === "List") {
                    inputType = "List";
                } else if (row.attributedata.templatetypeandattribute.attribute.attrtype === "Long Text") {
                    inputType = "Long Text";
                } else {
                    inputType = "text";
                }

                setRows(prevRows => [
                    ...prevRows,
                    {
                        authorid: 0,
                        label: row.attributedata.templatetypeandattribute.attribute.attrname,
                        templatesandattributedataid: row.id,
                        datajson: [],
                        inputType,
                        isEditing: true,
                        required: row.attributedata.datarequired,
                        multilanguage: row.attributedata.multilanguage,
                        mask: row.attributedata.mask,
                        listtypedatajson: row.attributedata.templatetypeandattribute.attribute.listtypedatajson
                    }
                ]);

            });
        } catch (error) {
            setAttr([]);
        }
    };


    useEffect(() => {
        if (templateType) {
            fetchAttrDetails();
        }
    }, [templateType]);

    const handleInputChange = (field, value) => {
        if (field === "uniqueid" || field === "orcid") {
            const orcidPattern = /^https:\/\/orcid\.org\/(.+)$/;
            const match = value.match(orcidPattern);
            const extractedValue = match ? match[1] : value;

            setAuthor(prevState => ({
                ...prevState,
                [field]: extractedValue
            }));
        } else if (field === "email") {
            if (!validateEmail(value)) {
                setEmailError("Geçersiz e-posta formatı!");
            } else {
                setEmailError("");

            }
            setAuthor(prevState => ({
                ...prevState,
                [field]: value
            }));
        } else {
            setAuthor(prevState => ({
                ...prevState,
                [field]: value
            }));
        }
    };

    // Email doğrulama fonksiyonu
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };



    const handleContactInputChange = (index, field, value) => {
        const updatedContacts = [...author.contactpersonSaveDTOList];
        updatedContacts[index][field] = value;
        if (field === 'eposta') {
            if (!validateEmail(value)) {
                setEmailError('Geçersiz e-posta formatı');
            } else {
                setEmailError('');
            }
        }
        setAuthor({ ...author, contactpersonSaveDTOList: updatedContacts });
    };

    const addNewContact = () => {
        setAuthor({
            ...author,
            contactpersonSaveDTOList: [...author.contactpersonSaveDTOList, { name: '', surname: '', unvan: '', job: '', telefon: '', eposta: '' }]
        });
    };

    const handleContactRemove = (index) => {
        const updatedContacts = author.contactpersonSaveDTOList.filter((_, i) => i !== index);
        setAuthor({ ...author, contactpersonSaveDTOList: updatedContacts });
    };



    const handleLanguageSelect = (e) => {
        const selectedLanguage = e.target.value;
        if (selectedLanguage && !selectedLanguages.includes(selectedLanguage)) {
            setSelectedLanguages([...selectedLanguages, selectedLanguage]);
        }
    };

    const handleEditorChange = (language, data) => {
        setAuthor((prevAuthor) => ({
            ...prevAuthor,
            detailedinformation: {
                ...prevAuthor.detailedinformation,
                [language]: data
            },
        }));

    };


    const getSelectableTemplates = () => {
        const selectedTemplateIds = author.authorstemplatesandattributedataSaveDTOList.map(item => item.templatesandattributedataid);
        return templates.filter(template => !selectedTemplateIds.includes(template.id));
    };

    const [isSaving, setIsSaving] = useState(false);


    const handleSave = async (isNew = false, redirect = false) => {

        if (isSaving) return;
        setIsSaving(true);

        const isEmailValid = author.contactpersonSaveDTOList.every(contact => validateEmail(contact.eposta));

        if (!isEmailValid) {
            toast.error('E-posta adresi formatı geçersiz. Lütfen kontrol ediniz.');
            return;
        }

        const hasEmptyRequiredFields = rows.some(attribute => {
            const isRequired = attribute.required === true;
            const isEmpty = !attribute.datajson || attribute.datajson.length === 0;
            let email = true;
            if (attribute.label === 'E-mail' || attribute.label === 'Eposta') {
                email = validateEmail(attribute.datajson);
            }
            return isRequired && isEmpty && email;
        });

        if (hasEmptyRequiredFields) {
            const emptyFields = rows.filter(attribute => {
                const isRequired = attribute.required === true;
                const isEmpty = !attribute.datajson || attribute.datajson.length === 0;
                return isRequired && isEmpty;
            });

            emptyFields.forEach(attribute => {
                toast.error(`${attribute.label} boş bırakılamaz.`);
            });

            return;
        }

        const formData = new FormData();
        const authorData = {
            uniqueid: author.uniqueid,
            name: author.name,
            surname: author.surname,
            photo: author.photo,
            title: author.title,
            yokid: author.yokid,
            institution: author.institution,
            faculty: author.faculty,
            department: author.department,
            email: author.email,
            orcid: author.orcid,
            contactpersonSaveDTOList: author.contactpersonSaveDTOList,
            authorcustomerrepSaveDTOList: author.authorcustomerrepSaveDTOList,
            authorstemplatesandattributedataSaveDTOList: author.authorstemplatesandattributedataSaveDTOList,
            detailedinformation: author.detailedinformation
        };

        formData.append('authorData', JSON.stringify(authorData));
        files.forEach((file) => {
            formData.append('files', file);
        });
        formData.append('attributes', JSON.stringify(attributes));
        formData.append('languages', JSON.stringify(languages));

        try {
            const response = await fetch('https://idealonline.com.tr/service/idealonline/v1/authors/create', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                body: formData
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Bir hata oluştu.');
            }

            toast.success(data.message);

            if (data.data.id) {
                await uploadPhoto(data.data.id);
            }

            if (isNew) {
                setAuthor({
                    uniqueid: '',
                    name: '',
                    surname: '',
                    phone: '',
                    email: '',
                    photo: '',
                    title: '',
                    yokid: '',
                    institution: '',
                    faculty: '',
                    department: '',
                    orcid: '',
                    contactpersonSaveDTOList: [],
                    authorcustomerrepSaveDTOList: [],
                    authorstemplatesandattributedataSaveDTOList: [],
                    detailedinformation: {}
                });
            } else if (redirect) {
               window.location.href = '/admin/authors';
            } else {
               window.location.href = '/admin/author/' + data.data.id;
            }
        } catch (error) {
            toast.error(error.message || 'Bir hata oluştu.');
        } finally {
            setIsSaving(false);
        }
    };




    const navigate = useNavigate();


    const fetchUniqId = async () => {
        try {
            const response = await uniqueidSearch(author.uniqueid, token);
            setAuthor({
                ...author,
                name: response.data.name,
                surname: response.data.surname,
                department: response.data.department,
                email: response.data.email,
                faculty: response.data.faculty,
                institution: response.data.institution,
                orcid: response.data.orcid,
                title: response.data.title,
                yokid: response.data.yokid,
            });
            toast.success(response.data.resultposition);
           
        } catch (error) {
            toast.error(error.response.data.message);
        }
    };

    const searchUniq = async () => {
        fetchUniqId();
        if (emailInputRef.current) {
            emailInputRef.current.focus();
        }
    };

    // Yeni satır ekleme
    const addNewRow = () => {
        if (templateType) {
            setRows([...rows, { authorid: 0, templatesandattributedataid: '', datajson: [], inputType: '', isEditing: true }]);

            setEditingRowIndex(rows.length);
        } else {
            toast.error("Yazar Bilgileri Eklemek İçin Şablon Seçiniz.")
        }
    };

    const addNewRowSave = () => {
        rows.map((row, index) => {
            saveRow(index)
        });
    };



    const handleInputChange2 = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    // Satırı kaydet
    const saveRow = (index) => {
        const updatedRows = [...rows];
        if ((updatedRows[index].datajson.length > 0 && updatedRows[index].required == 1) || updatedRows[index].required == 0) {
            updatedRows[index].isEditing = false;
            if (updatedRows[index].inputType === 'file') {
                setFiles(prevFiles => [...prevFiles, updatedRows[index].datajson[0]]);

                setAttributes(prevAttributes => [
                    ...prevAttributes,
                    updatedRows[index].templatesandattributedataid
                ]);
                setLanguages(prevLanguages => [
                    ...prevLanguages,
                    updatedRows[index].language
                ]);
            } else {
                const newAttributeData = {
                    templatesandattributedataid: updatedRows[index].templatesandattributedataid,
                    datajson: [
                        {
                            "lang": updatedRows[index].language || "tr",
                            "value": JSON.parse(JSON.stringify(Array.isArray(updatedRows[index].datajson) ? updatedRows[index].datajson : [updatedRows[index].datajson])),
                        },

                    ],
                    authorid: 0
                };
                setAuthor(prevState => {
                    const existingIndex = prevState.authorstemplatesandattributedataSaveDTOList.findIndex(
                        item => item.templatesandattributedataid === newAttributeData.templatesandattributedataid
                    );

                    if (existingIndex !== -1) {
                        const updatedAttributes = [...prevState.authorstemplatesandattributedataSaveDTOList];
                        updatedAttributes[existingIndex] = newAttributeData;
                        return {
                            ...prevState,
                            authorstemplatesandattributedataSaveDTOList: updatedAttributes
                        };
                    } else {
                        return {
                            ...prevState,
                            authorstemplatesandattributedataSaveDTOList: [
                                ...prevState.authorstemplatesandattributedataSaveDTOList,
                                newAttributeData
                            ]
                        };
                    }
                });
            }

            setRows(updatedRows);
            setEditingRowIndex(null);
        } else {
            toast.error("Lütfen tüm gerekli alanları doldurun")
        }
    };

    const getSelectableAttributes = () => {
        const selectedAttributeIds = author.authorstemplatesandattributedataSaveDTOList.map(item => item.templatesandattributedataid);
        return attr.filter(attribute => !selectedAttributeIds.includes(attribute.id));
    };


    // Satırı düzenleme moduna al
    const editRow = (index) => {
        setEditingRowIndex(index);
        const updatedRows = [...rows];
        updatedRows[index].isEditing = true;
        setRows(updatedRows);
    };

    // Satırı sil
    const deleteRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);

        // Silinen satırı authorstemplatesandattributedataSaveDTOList'ten çıkar
        setAuthor(prevState => ({
            ...prevState,
            authorstemplatesandattributedataSaveDTOList: prevState.authorstemplatesandattributedataSaveDTOList.filter((_, i) => i !== index)
        }));
    };


    // Temsilcilerdeki değişiklikleri yakalamak için yeni bir fonksiyon
    const handleRepresentativeChange = (index, field, value) => {
        const updatedRepresentatives = [...author.authorcustomerrepSaveDTOList];
        updatedRepresentatives[index] = {
            ...updatedRepresentatives[index],
            [field]: value,
            authorid: 0
        };
        setAuthor({ ...author, authorcustomerrepSaveDTOList: updatedRepresentatives });
    };



    // Temsilciyi silmek için yeni bir fonksiyon
    const removeRepresentative = (index) => {
        const updatedRepresentatives = author.authorcustomerrepSaveDTOList.filter((_, i) => i !== index);
        setAuthor({ ...author, authorcustomerrepSaveDTOList: updatedRepresentatives });
    };

    const addNewRepresentative = () => {
        setAuthor({
            ...author,
            authorcustomerrepSaveDTOList: [
                ...author.authorcustomerrepSaveDTOList,
                { userid: '', job: '', authorid: 0 }
            ]
        });
    };
    const [photoPreview, setPhotoPreview] = useState(User17);
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPhoto(file);
            setPhotoPreview(URL.createObjectURL(file));
        }
    };

    const uploadPhoto = async (authorId) => {
        if (photo) {
            const formData = new FormData();
            formData.append('photo', photo);

            try {
                const response = await fetch(`https://idealonline.com.tr/service/idealonline/v1/authors/photoSave/${authorId}/-1`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                    body: formData,
                });

                const data = await response.json();
                toast.success(data.message);

            } catch (error) {
                console.error('Resim yüklenirken hata oluştu:', error);
                toast.error(error.response.data.message);
            }
        }
    };

    const handleRemoveLanguage = (language) => {
        setSelectedLanguages(selectedLanguages.filter((lang) => lang !== language));
        setAuthor((prevAuthor) => {
            const updatedDetails = { ...prevAuthor.detailedinformation };
            delete updatedDetails[language];
            return { ...prevAuthor, detailedinformation: updatedDetails };
        });
    };


    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggleTooltip = () => {
        setTooltipOpen(!tooltipOpen);
    };

    const handleMaxLengthWarning = (name, value, maxLength) => {
        if (value.length >= maxLength) {
            toast.error(`${name} alanı ${maxLength} karakter sınırına ulaştı!`);
        }
    };



  return (
    <div className="main-wrapper">
      <Header activeMenu={"CreateAuthor"} />
      <div className="breadcrumb-bar breadcrumb-bar-info">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12 mt-5">
              <div className="breadcrumb-list">
                <h2 className="breadcrumb-title">Yazar Profili Oluştur</h2>
                <nav aria-label="breadcrumb" className="page-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/home">Ana Sayfa</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Yazar Profili Oluştur
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="row">
            <Sidebar />
            <div className="col-xl-9 col-lg-9">
              <div className="settings-widget card-details">
                <div className="settings-menu p-0">
                  <div className="profile-heading">
                    <h3>Yazar Profili Oluştur</h3>
                  </div>
                  <form >
                    <div className="checkout-form settings-wrap">
              
                                <Row>
                                    <Col md="2">
                                        <div className="d-flex flex-column align-items-center">
                                            <img src={photoPreview} className="img-fluid mb-3" alt="Yazar Fotoğrafı" />
                                            <div>
                                                <label htmlFor="photo-upload" className="btn btn-light">
                                                    Fotoğraf Seç
                                                </label>
                                                <FormControl
                                                    id="photo-upload"
                                                    className="photo"
                                                    type="file"
                                                    style={{ display: 'none' }}
                                                    onChange={handleFileChange}
                                                />
                                            </div>

                                        </div>
                                    </Col>

                                    <Col md="10">
                                        <Row>
                                            <Col md="6">
                                                <FormGroup>
                                                    <FormLabel for="uniqueid" id="uniqueid-tooltip" style={{ cursor: 'pointer' }}>
                                                        <Info className="me-1 text-primary" />
                                                        Belirteç
                                                    </FormLabel>
                                                   <InputGroup>
                                                        <FormControl
                                                            type="text"
                                                            id="uniqueid"
                                                            maxLength={100}
                                                            value={author.uniqueid}
                                                            onChange={(e) => {
                                                                handleInputChange('uniqueid', e.target.value);
                                                                handleMaxLengthWarning("Belirteç", e.target.value, 100);
                                                            }}
                                                        />
                                                        <Button color="warning" onClick={searchUniq}>
                                                            <Search />
                                                        </Button>
                                                    </InputGroup>
                                                    {/* Tooltip Ekleme */}
                                                    <Tooltip
                                                        placement="top"
                                                        isOpen={tooltipOpen}
                                                        target="uniqueid-tooltip"
                                                        toggle={toggleTooltip}
                                                    >
                                                        YÖKID veya ORCID bilgisine göre arama yapınız.
                                                    </Tooltip>
                                                </FormGroup>
                                            </Col>

                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <FormGroup>
                                                    <FormLabel for="name">Ad</FormLabel>
                                                    <FormControl
                                                        maxLength={100}
                                                        type="text"
                                                        id="name"
                                                        value={author.name}
                                                        onChange={(e) => {
                                                            handleInputChange('name', e.target.value);
                                                            handleMaxLengthWarning("Ad", e.target.value, 100);
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <FormLabel for="surname">Soyad</FormLabel>
                                                    <FormControl
                                                        maxLength={100}
                                                        type="text"
                                                        id="surname"
                                                        value={author.surname}
                                                        onChange={(e) => {
                                                            handleInputChange('surname', e.target.value);
                                                            handleMaxLengthWarning("Soyad", e.target.value, 100);
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <FormLabel for="department">Email</FormLabel>
                                                    <FormControl
                                                        innerRef={emailInputRef}
                                                        maxLength={100}
                                                        type="email"
                                                        id="email"
                                                        required
                                                        value={author.email}
                                                        onChange={(e) => {
                                                            handleInputChange('email', e.target.value);
                                                            handleMaxLengthWarning("E-posta", e.target.value, 100);
                                                        }}
                                                    />
                                                    {emailError && (
                                                        <div className="text-danger fw-bold">{emailError}</div>
                                                    )}
                                                </FormGroup>

                                            </Col>

                                            <Col md="6">
                                                <FormGroup>
                                                    <FormLabel for="title">Ünvan</FormLabel>


                                                    <select
                                                        id="title"
                                                        value={author.title}
                                                        onChange={(e) => handleInputChange('title', e.target.value)}
                                                        className="form-control"
                                                    >
                                                        <option value="" disabled>
                                                            Ünvan Seçiniz
                                                        </option>
                                                        {titleList.map((title, idx) => (
                                                            <option key={idx} value={title}>
                                                                {title}
                                                            </option>
                                                        ))}
                                                    </select>


                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <FormLabel for="yokid">YÖK ID</FormLabel>
                                                    <FormControl
                                                        maxLength={100}
                                                        type="text"
                                                        id="yokid"
                                                        value={author.yokid}
                                                        onChange={(e) => {
                                                            handleInputChange('yokid', e.target.value);
                                                            handleMaxLengthWarning("Soyad", e.target.value, 100);
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col md="6">
                                                <FormGroup>
                                                    <FormLabel for="yokid">Orcid</FormLabel>
                                                    <FormControl
                                                        maxLength={100}
                                                        type="text"
                                                        id="orcid"
                                                        value={author.orcid}
                                                        onChange={(e) => {
                                                            handleInputChange('orcid', e.target.value);
                                                            handleMaxLengthWarning("Soyad", e.target.value, 100);
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <UniversitySelector author={author} setAuthor={setAuthor} token={token} />


                                        </Row>


                                        {selectedLanguages.map((language) => {
                                            const languageName = languageOptions.find((lang) => lang.key === language)?.value || language.toUpperCase();
                                            return (
                                                <div key={language} className="mt-4">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <h6>{languageName} için Detaylı Bilgi</h6>
                                                        <Button color="danger" size="sm" onClick={() => handleRemoveLanguage(language)}>
                                                            Sil
                                                        </Button>
                                                    </div>
                                                    <CKEditor
                                                        editor={ClassicEditor}
                                                        config={{
                                                            toolbar: [
                                                                'heading', 'bold', 'italic', 'underline',
                                                                'strikethrough', 'subscript', 'superscript',
                                                                'bulletedList', 'numberedList',
                                                                'alignment', 'fontColor', 'fontBackgroundColor',
                                                                'undo', 'redo', 'blockQuote', 'horizontalLine',
                                                                'code', 'codeBlock', 'lineHeight'
                                                            ],
                                                            placeholder: 'Metni buraya yazın...',
                                                        }}
                                                        data={author.detailedinformation[language] || ''}
                                                        onChange={(event, editor) => {
                                                            const data = editor.getData();
                                                            setAuthor((prevAuthor) => ({
                                                                ...prevAuthor,
                                                                detailedinformation: {
                                                                    ...prevAuthor.detailedinformation,
                                                                    [language]: data
                                                                }
                                                            }));
                                                        }}
                                                    />
                                                </div>
                                            );
                                        })}


<FormGroup className="mt-4">
  <FormLabel htmlFor="languageSelect">Detaylı Bilgi Eklemek İstediğiniz Dili Seçiniz.</FormLabel>
  <Form.Select
    id="languageSelect"
    value=""
    onChange={(e) => {
      const selectedLanguage = e.target.value;
      if (selectedLanguage && !selectedLanguages.includes(selectedLanguage)) {
        setSelectedLanguages([...selectedLanguages, selectedLanguage]);
        setAuthor((prevAuthor) => ({
          ...prevAuthor,
          detailedinformation: {
            ...prevAuthor.detailedinformation,
            [selectedLanguage]: ''
          }
        }));
      }
      e.target.value = "";
    }}
  >
    <option value="">Dil Seçin</option>
    {languageOptions
      .filter(lang => !selectedLanguages.includes(lang.key))
      .map((lang) => (
        <option key={lang.key} value={lang.key}>
          {lang.value}
        </option>
      ))}
  </Form.Select>
</FormGroup>





                                    </Col>
                                </Row>
                      
  <Card.Header>
    <Row className="align-items-center">
      <Col md={6}>
        <h5>Yazar Bilgileri</h5>
      </Col>
      <Col md={6}>
        <Form.Group controlId="templateType">
          <Form.Select
            value={templateType}
            onChange={(e) => setTemplateType(e.target.value)}
          >
            <option value="">Şablon Seçiniz</option>
            {templates.map((template) => (
              <option key={template.id} value={template.id}>
                {template.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
    </Row>
  </Card.Header>
  <Card.Body>
    <Table responsive bordered>
      <tbody>
        {rows.map((row, index) => (
          <tr key={index}>
            <td>
              {row.isEditing ? (
                <Form.Select
                  disabled
                  value={row.templatesandattributedataid}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedAttr = attr.find(
                      option => option.id === parseInt(selectedId, 10)
                    );
                    if (selectedAttr) {
                      // Tüm değer atamaları buraya gelecek (handleInputChange2 vs.)
                      handleInputChange2(index, 'templatesandattributedataid', selectedId);
                      handleInputChange2(index, 'label', selectedAttr.attributedata.templatetypeandattribute.attribute.attrname);
                      // vs.
                    }
                  }}
                >
                  <option value="">Seçin</option>
                  {attr.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.attributedata.templatetypeandattribute.attribute.attrname}
                    </option>
                  ))}
                </Form.Select>
              ) : (
                <span>{row.label} ({row.language})</span>
              )}
            </td>

            <td>
              {row.isEditing ? (
                <>
                  {row.inputType === "text" && (
                    <Form.Control
                      type="text"
                      value={row.datajson}
                      onChange={(e) => handleInputChange2(index, 'datajson', e.target.value)}
                    />
                  )}
                  {row.inputType === "file" && (
                    <Form.Control
                      type="file"
                      onChange={(e) => handleInputChange2(index, 'datajson', [e.target.files[0]])}
                    />
                  )}
                  {row.inputType === "list" && (
                    <Form.Select
                      value={row.datajson}
                      onChange={(e) => handleInputChange2(index, 'datajson', e.target.value)}
                    >
                      <option value="">Seçin</option>
                      {row.listtypedatajson?.map((opt, i) => (
                        <option key={i} value={opt}>{opt}</option>
                      ))}
                    </Form.Select>
                  )}
                  {row.inputType === "Long Text" && (
                    <CKEditor
                      editor={ClassicEditor}
                      data={row.datajson}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        handleInputChange2(index, 'datajson', data);
                      }}
                    />
                  )}
                  {row.multilanguage === 1 && (
                    <Form.Select
                      className="mt-2"
                      value={row.language || ''}
                      onChange={(e) => handleInputChange2(index, 'language', e.target.value)}
                    >
                      <option value="">Dil Seçin</option>
                      {availableLanguages.map((lang, i) => (
                        <option key={i} value={lang}>
                          {lang === 'tr' ? 'Türkçe' : 'İngilizce'}
                        </option>
                      ))}
                    </Form.Select>
                  )}
                </>
              ) : (
                <span>
                  {row.inputType === 'file'
                    ? row.datajson?.[0]?.name || '---'
                    : Array.isArray(row.datajson)
                    ? row.datajson.join(', ')
                    : row.datajson || '---'}
                </span>
              )}
            </td>

            <td>
              {row.isEditing ? (
                <Button
                  variant="success"
                  size="sm"
                  onClick={() => saveRow(index)}
                >
                  Kaydet
                </Button>
              ) : (
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => editRow(index)}
                >
                  Düzenle
                </Button>
              )}
            </td>
          </tr>
        ))}

        <tr>
          <td colSpan="3">
            <Button
              variant="warning"
              size="sm"
              className="ms-2"
              onClick={addNewRowSave}
            >
              Tümünü Kaydet
            </Button>
          </td>
        </tr>
      </tbody>
    </Table>
  </Card.Body>



                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
      <Footer />
    </div>
  );
};

export default CreateAuthor;
